import { TooltipProvider } from '@/components/ui/tooltip';
import { AuthBootstrap } from '@/features/auth/auth-bootstrap';
import { ThemeProvider } from '@/features/theme/ThemeProvider';
import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ThemeProvider>
      <TooltipProvider delayDuration={150}>
        <AuthBootstrap>
          <Outlet />
        </AuthBootstrap>
      </TooltipProvider>
    </ThemeProvider>
  );
}
